import React from "react";
const SearchIcon = (props) =>  (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
       {...props}
    >
      <path
        fill="#1A1A1A"
        d="m15.283 14.218-2.783-2.76a6.75 6.75 0 1 0-1.042 1.042l2.76 2.76a.75.75 0 0 0 1.065 0 .75.75 0 0 0 0-1.042M7.25 12.5A5.25 5.25 0 1 1 7.25 2a5.25 5.25 0 0 1 0 10.501"
      ></path>
    </svg>
  );


export default SearchIcon;
